import Icon from '../components/Icon.vue'

Icon.register({"search":{"width":1664,"height":1792,"paths":[{"d":"M1152 832q0-185-131.5-316.5t-316.5-131.5-316.5 131.5-131.5 316.5 131.5 316.5 316.5 131.5 316.5-131.5 131.5-316.5zM1664 1664q0 52-38 90t-90 38q-54 0-90-38l-343-342q-179 124-399 124-143 0-273.5-55.5t-225-150-150-225-55.5-273.5 55.5-273.5 150-225 225-150 273.5-55.5 273.5 55.5 225 150 150 225 55.5 273.5q0 220-124 399l343 343q37 37 37 90z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/search.js
// module id = 846
// module chunks = 0